import { render, staticRenderFns } from "./TeacherEditDialog.vue?vue&type=template&id=44061421&scoped=true"
import script from "./TeacherEditDialog.vue?vue&type=script&lang=js"
export * from "./TeacherEditDialog.vue?vue&type=script&lang=js"
import style0 from "./TeacherEditDialog.vue?vue&type=style&index=0&id=44061421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44061421",
  null
  
)

export default component.exports